import { ChangeBillingStatusService } from './../A2-utils/change-billing-status-trip/change-billing-status.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingGeneralRoutingModule } from './billing-general-routing.module';
import { WorkflowsComponent } from './workflows/workflows.component';
import { BatchHistoryComponent } from './batch-history/batch-history.component';
import { MyDatePickerModule } from 'mydatepicker';
import { Select2Module } from '../A2-utils/select2/select2.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { ExportComponent } from '../data-processing/components/export/export.component';
import { AgGridModule } from 'ag-grid-angular';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { EditReservationModule } from '../trip-reservations/edit-reservation/edit-reservation.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from 'app/directives/directives.module';
import { DataProcessingService } from '../data-processing/data-processing.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ChangeBillingStatusTripComponent } from '../A2-utils/change-billing-status-trip/change-billing-status-trip.component';
import { GenericReportingService } from 'app/core/services/genericReporting.service';
import { PostingComponent } from './posting/posting.component';
import { FormPostingBatchComponent } from './posting/form-posting-batch/form-posting-batch.component';
import { ImportPostingBatchComponent } from './posting/import-posting-batch/import-posting-batch.component';
import { GridPostingBatchComponent } from './posting/grid-posting-batch/grid-posting-batch.component';
import { PostingService } from 'app/core/services/posting.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { AutofillPostingBatchComponent } from './posting/autofill-posting-batch/autofill-posting-batch.component';
import { DenialCodeModule } from 'app/utils/denial-code/denial-code.module';
import { AutoCompleteDenialCodeModule } from 'app/utils/auto-complete-denial-code/auto-complete-denial-code.module';
import { BilledModule } from './billed/billed.module';
import { ModalChargesDetailsComponent } from './posting/modal-charges-details/modal-charges-details.component';
import { CreditEditComponent } from './posting/credit-edit/credit-edit.component';
import { EdiFilesComponent } from './edi-files/edi-files.component';
import { EdiFilesService } from './edi-files/edi-files.service';
import { BtnsForGridModule } from 'app/utils/btns-for-grid/btns-for-grid.module';
import { EncountersComponent } from './Encounters/encounters.component';
import { EncountersGridComponent } from './Encounters/encounters-grid/encounters-grid.component';
import { ChangeModifierModule } from '../change-modifier/change-modifier.module';
import { PrePostingComponent } from './posting/pre-posting/pre-posting/pre-posting.component';
import { DepositsComponent } from './deposits/deposits.component';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { DepositsDetailsComponent } from './deposits/deposits-details/deposits-details.component';
import { AutocompletePayorsModule } from 'app/utils/autocomplete-payors/autocomplete-payors.module';
import { AutocompleteAccountNumberModule } from 'app/utils/autocomplete-account-number/autocomplete-account-number.module';
import { MonthPickerModule } from 'app/utils/month-picker/month-picker.module';
import { LockboxComponent } from './deposits/lockbox/lockbox.component';
import { PostedComponent } from './deposits/posted/posted.component';
import { DepositsDetailsCopyPasteComponent } from './deposits/deposits-details-copy-paste/deposits-details-copy-paste.component';
import { BtnCellRendererComponent } from '../A2-utils/grid-components/btn-cell-renderer/btn-cell-renderer.component';
import { ConciliationComponent } from './deposits/conciliation/conciliation.component';
import { OfficeDepositComponent } from './deposits/office-deposit/office-deposit.component';
import { ElectronicComponent } from './deposits/electronic/electronic.component';
import { EditPostedModuleModule } from './deposits/posted/edit-posted/edit-posted-module.module';
import { CustomFooterGridModule } from '../custom-footer-grid/custom-footer-grid.module';
import { ElectronicDetailsComponent } from './deposits/electronic-details/electronic-details.component';
import { GridLayoutMenuModule } from 'app/utils/grid-layout-menu/grid-layout-menu.module';

@NgModule({
  imports: [
    CommonModule,
    BillingGeneralRoutingModule,
    Trip2ThemeModule,
    FormsModule,
    DirectivesModule,
    MyDateRangePickerModule,
    Select2Module,
    MyDatePickerModule,
    AgGridModule.withComponents([BtnCellRendererComponent]),
    EditReservationModule,
    NgMultiSelectDropDownModule.forRoot(),
    ReactiveFormsModule,
    AngularMultiSelectModule,
    DenialCodeModule,
    AutocompletePayorsModule,
    AutocompleteAccountNumberModule,
    AutoCompleteDenialCodeModule,
    BilledModule,
    BtnsForGridModule,
    GridLayoutMenuModule,
    ChangeModifierModule,
    MonthPickerModule,
    EditPostedModuleModule,
    CustomFooterGridModule
  ],
  declarations: [
    WorkflowsComponent,
    BatchHistoryComponent,
    ExportComponent,
    ChangeBillingStatusTripComponent,
    PostingComponent,
    FormPostingBatchComponent,
    ImportPostingBatchComponent,
    GridPostingBatchComponent,
    AutofillPostingBatchComponent,
    ModalChargesDetailsComponent,
    CreditEditComponent,
    EdiFilesComponent,
    EncountersComponent,
    EncountersGridComponent,
    PrePostingComponent,
    DepositsComponent,
    DepositsDetailsComponent,
    LockboxComponent,
    PostedComponent,
    DepositsDetailsCopyPasteComponent,
    ConciliationComponent,
    OfficeDepositComponent,
    ElectronicComponent,
    ElectronicDetailsComponent
  ],
  providers: [
    DataProcessingService,
    ChangeBillingStatusService,
    PostingService,
    T2LoadingService,
    GenericReportingService,
    EdiFilesService,
    ConciliationService
  ]
})
export class BillingGeneralModule { }



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/billing-general.module.ts